import router from './router'
import store from './store'
import { getToken } from '@/utils/auth' // get token from cookie
import { headerInfo } from "@/api/header";
const home = () => import('@/pages/home/home')
const searchIndustry = () => import('@/pages/search/search_from_industry')
const album = () => import('@/pages/album/album')
// const play=()=>import('@/pages/play/play')
const play = () => import('@/pages/play/index')
const personal = () => import('@/pages/personal/personal')
const study = () => import('@/pages/study/study')
const login = () => import('@/pages/login/index')
const homework = () => import('@/pages/homework')
const noPage = () => import('@/pages/error-page/404')
let accessRoutes = [
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {
      title: '',
      description: '',
      keywords: ''
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: login,
    meta: {
      title: '',
      description: '',
      keywords: ''
    }
  },
  {
    path: '*',
    name: 'noFound',
    component: noPage,
    meta: {
      title: ''
    }
  }
]
let stuRoutes = [
  {
    path: '/',
    name: 'home',
    redirect:'/s/mycourse'
  },
  {
    path: '/login',
    name: 'Login',
    component: login,
    meta: {
      title: '',
      description: '',
      keywords: ''
    }
  },
  {
    path: '*',
    name: 'noFound',
    component: noPage,
    meta: {
      title: ''
    }
  }
]

router.beforeEach(async (to, from, next) => {
  
  if (to.path=='/404page'||to.path=='/expired'||to.path=='/405page') {
    next()
    return;
  } 
  const hasToken = getToken()
  const hasHome = store.getters && store.getters.perhome

  if (hasHome == '') {
    let website = await store.dispatch('generateRoutes');
    let orgInfo = await store.dispatch('user/getOrgInfo');
    if (hasToken) {
      let userInfo = await store.dispatch('user/getInfo');
    }
    if (website.is_home == 1) {
      router.addRoutes(accessRoutes)
    } else if (website.is_home == 2){
      router.addRoutes(stuRoutes)
    }
    if (website.no_login_home == 2&&!hasToken) {
      next(`/login`)
    }else if(website.is_pc == 2 && typeof wf == 'undefined'){
      next(`/405page`)
    }else{
      next({ ...to, replace: true })
    }
    
  }else if (hasHome==2&&!hasToken) {
    if (to.path == '/login') {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
    }
  } else if (to.matched.length === 0) { // 如果未匹配到路由
   
    from.path ? next({ path: from.path }) : next('/') // 如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
  } else {
    next() // 如果匹配到正确跳转
  }
})



// WEBPACK FOOTER //
// ./src/permission.js